export default {
	
	/**
	 * Create cookie
	 * @param {string} name
	 * @param {string} value
	 * @param {number} days
	 */
	create(name, value, days = null) {
		let expires = '';
		if (days) {
			const date = new Date();
			const one_day = 24 * 60 * 60 * 1000;
			date.setTime(date.getTime() + (days * one_day));
			expires = `; expires=${date.toGMTString()}`;
		}
		document.cookie = `${name}=${value}${expires}; path=/`;
	},
	
	
	/**
	 * Read cookie
	 * @param {string} name
	 * @return {string}
	 */
	read(name) {
		const name_eq = `${name}=`;
		const all_cookies = document.cookie.split(';');
		
		for (let cookie of all_cookies) {
			while (cookie.charAt(0) === ' ') {
				cookie = cookie.substring(1, cookie.length);
			}
			if (cookie.indexOf(name_eq) === 0) {
				return cookie.substring(name_eq.length, cookie.length);
			}
		}
		
		return null;
	},
	
	
	/**
	 * Erase cookie
	 * @param {string} name
	 */
	erase(name) {
		this.create(name, '', -1);
	},
	
};
